import { render, staticRenderFns } from "./sync-archived-popup.component.vue?vue&type=template&id=32dd314a&scoped=true&"
import script from "./sync-archived-popup.component.vue?vue&type=script&lang=js&"
export * from "./sync-archived-popup.component.vue?vue&type=script&lang=js&"
import style0 from "./sync-archived-popup.component.vue?vue&type=style&index=0&id=32dd314a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd314a",
  null
  
)

export default component.exports